import { parcelPhotoIdFormat } from "@redotech/redo-ids-cockroach";
import { ParcelPhotoSource } from "@redotech/redo-model/fulfillments/parcel-photo";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

/**
 * Lists confirmed (non-deleted) parcel photos attached to an FG. Used
 * by the verify page on mount to hydrate the thumbnail strip when an
 * operator returns to a partially-shot session, and by admin / support
 * views to render evidence.
 *
 * Returns photos sorted by `capturedAt` ascending so the strip reads
 * left-to-right in capture order.
 */
export const getParcelPhotos = {
  name: "getParcelPhotos" as const,
  input: z.object({ fulfillmentGroupId: zExt.objectId() }),
  output: z.object({
    photos: z.array(
      z.object({
        photoId: parcelPhotoIdFormat.schema,
        url: z.string(),
        width: z.number().int().positive(),
        height: z.number().int().positive(),
        sizeBytes: z.number().int().nonnegative(),
        contentType: z.string(),
        capturedAt: z.coerce.date(),
        confirmedAt: z.coerce.date().nullish(),
        capturedByUserId: zExt.objectId().nullish(),
        source: createEnum(ParcelPhotoSource, {
          enumName: "ParcelPhotoSource",
        }),
      }),
    ),
  }),
};
